import {Component, OnInit} from '@angular/core';
import {FormBuilder, FormGroup, ValidatorFn} from '@angular/forms';
import {ActivatedRoute, Router} from '@angular/router';
import {PopinService} from '../services/popin.service';
import {Popin} from '../models/popin.model';
import {takeUntil} from 'rxjs/operators';
import {timer} from 'rxjs';
import {ApiCoefficyService} from '../services/api-coefficy.service';
import {Data} from '../providers/data.provider';
import {IpService} from '../services/ip.service';
import {DatasaveService} from '../services/datasave.service';

function popin() {
  const navigationBlock = document.createElement('div');
  navigationBlock.className = 'navBlock';
  navigationBlock.setAttribute('style', 'z-index:999; position:fixed; height:100%; width:100%;' +
    'top:0; left:0; overflow:hidden; background-color:rgba(0,0,0,0.5);');
  document.body.appendChild(navigationBlock);

  const popup = document.createElement('div');
  popup.className = 'popup';
  // Popin side
  popup.setAttribute('style', 'z-index:1000; position:fixed; right:20px; bottom:20px;' +
    'height:30%; width:30%; min-height:300px; min-width:400px; top:auto; left:auto; background-color:white;');
  // Popin center
  // popup.setAttribute('style', 'z-index:1000; position:fixed; right:auto; bottom:auto;' +
  // 'height:30%; width:30%; min-height:300px; min-width:400px; top:35%; left:35%;');

  const ifrm = document.createElement('iframe');
  ifrm.setAttribute('src', 'http://localhost:4200/popin');
  ifrm.setAttribute('frameborder', '0');
  ifrm.setAttribute('style', 'border:0; height:100%; min-height:200px; width:100%;' +
    'min-width:350px; box-shadow:5px 5px 5px rgba(0,0,0,0.5);');
  popup.appendChild(ifrm);
  document.body.appendChild(popup);
}

@Component({
  selector: 'app-test',
  templateUrl: './test.component.html',
  styleUrls: ['./test.component.scss']
})
export class TestComponent implements OnInit {

  constructor(private formBuilder: FormBuilder,
              private router: Router,
              private popinService: PopinService,
              private ipService: IpService,
              private coefficy: ApiCoefficyService,
              private datasaveService: DatasaveService,
              private data: Data,
              private route: ActivatedRoute) {}

  public static productCustomer: any = null;
  public static isCustomer = false;
  public static customer: any;
  public static popinId: string;
  public static host: string = null;
  public static uri: string = null;
  public static visitRandomId: string = null;
  public static popinOpened = false;
  public customerIdentifier: string;
  public isLoading: boolean;
  public AutoComplete$ = [];
  public timer: any;
  public error3s = false;
  public postalCode = /((0[1-9])|([1-8][0-9])|(9[0-8])|(2A)|(2B))[0-9]{3}/;
  public noresult = false;
  public titleColor: string;
  public position = 0;
  public borderRadius = true;
  public companyRequired = true;
  public loading = false;
  public popinForm: FormGroup;
  public popin: Popin;
  public webpageList: any = [];
  public webpageTest = false;
  public session: any;
  public geoloc: string;
  public title: string;
  public newCompanyLinkIsActive: string;
  public newCompanyLinkTitle: string;
  public newCompanyLinkUrl: string;

  ngOnInit(): void {
    this.loading = true;
    this.popinForm = this.formBuilder.group({
      autocompleteField: [null]
    });
    this.loadPopin();
  }

  loadPopin() {
          this.loading = false;
  }

  public change($event) {
    if ($event !== '') {
      if (typeof $event === 'object') {
        this.customerIdentifier = $event.siren;
        //this.onSubmit();
      } else if ($event.trim().length === 5 && this.postalCode.test($event.trim())) {
        this.AutoComplete$ = [];
      } else {
        if (this.timer == null) {
          this.autocomplete($event);
        } else {
          clearTimeout(this.timer);
          this.autocomplete($event);
        }
      }
    }
  }

  public autocomplete(searchTerm) {
    this.timer = setTimeout((newValidator: ValidatorFn | ValidatorFn[] | null) => {
      this.AutoComplete$ = [];
      this.error3s = false;
      this.isLoading = true;
      const request = this.coefficy.getFormData(searchTerm.replace(' ', '%20'));
      request.subscribe((res) => {
        if (typeof res === 'object') {
          const jsonObj = JSON.parse(JSON.stringify(res));
          if (jsonObj.length > 0) {
            this.noresult = false;
            for (const org of jsonObj) {
              if (org.website != null) {
                org.website = org.website.split("/")[2];
              }
              this.AutoComplete$.push(org);
            }
          } else {
            this.noresult = true;
          }
        }
      }, (err) => {
        console.log(err);
        this.isLoading = true;
        this.error3s = true;
      }, () => {
        this.isLoading = false;
        this.error3s = false;
      });
      // Test du CP et alerte si +3s
      if (!this.postalCode.test(searchTerm)) {
        timer(3000).pipe(takeUntil(request)).subscribe(next => {
          this.error3s = true;
        }, err => {
          console.log(err);
        });
      }
    }, 750);
  }

  public displayFn(org): string {
    return org ? org.companyName : org;
  }

}
